import ImageClass from "../../src/shell/Image";
import Question from "../../src/shell/Questions";
import { jump } from "../../src/shell/jump";
import { ann } from "../characters/Ann";
import { cashier } from "../characters/Cashier";
import { emily } from "../characters/Emily";
import { empty } from "../characters/empty";
import { mc } from "../characters/MC";
import { stranger } from "../characters/Stranger";
import { strangerFemale } from "../characters/StrangerFemale";
import { strangerTwo } from "../characters/StrangerTwo";
import { doPutMultipleImages, doTransition, doWaitImageByTime } from "../helpers/helpers";
import { images } from "./images";
import { V8AnnDateAfter } from "./V8";
import { endReplay } from "../../src/shell/endReplay";
import { replayScenesList } from "../../src/components/menu/Scenes/replayScenes/scenesReplayData";

export const V8AnnDate = async (): Promise<any> => {
    doTransition(images.v8.V8PickingUpAnn_0);
    mc.think(`I hope she is ready.`);
    doWaitImageByTime(images.v8.V8PickingUpAnn_1);
    mc.talk(`Wow. I didn't even knock.`);
    ImageClass.setImage(images.v8.V8PickingUpAnn_2);
    await ann.setQuestion(new Question({ text: `Hehe, I saw you through the window.`, options: { think: false }, key: `V8AnnDateComplimentedHer` })
        .option({ title: `Compliment her`, key: true })
        .option({ title: `Don't compliment`, key: false }));


    if (Question.globalAnswers.V8AnnDateComplimentedHer) {
        await mc.set((properties) => {
            properties.annRelationship++;
        });

        ImageClass.setImage(images.v8.V8PickingUpAnn_5);
        mc.talk(`You are looking great!`);
        ImageClass.setImage({ ...images.v8.V8PickingUpAnn_2, partialsToDisplay: [images.v8.V8PickingUpAnn_2.partials.V8PickingUpAnn_2_p] });
        ann.talk(`Hehe! Thank you!`);
        if (ann.properties.isCorrupted) {

        } else {
            ann.talk(`I usually only wear a dress for a special occasion, and of course, this is one!`);
        }


    } else {


    }
    if (ann.properties.isCorrupted) {
        ImageClass.setImage(images.v8.V8PickingUpAnnCorrupted_4);
        mc.talk(`By the way, is that a thong I'm seeing there?`);
        ImageClass.setImage(images.v8.V8PickingUpAnn_2.partials.V8PickingUpAnnCorrupted_2, { putParent: true });
        ann.talk(`Hehe, it is!`);
        mc.talk(`Prove it.`);
        ImageClass.setImage(images.v8.V8PickingUpAnnCorrupted_6);
        await mc.setQuestion(new Question({ text: `Nice!`, options: { think: false }, key: `v8AnnDateTouchedHerAss` })
            .option({ title: `Touch her ass`, key: true })
            .option({ title: `Don't touch`, key: false }));


        if (Question.globalAnswers.v8AnnDateTouchedHerAss) {
            ImageClass.setImage(images.v8.V8PickingUpAnnCorrupted_8, { wait: true });
            ImageClass.setImage(images.v8.V8PickingUpAnnCorrupted_9);
            ann.talk(`Oh! Hehe!`);
            mc.talk(`I couldn't resist.`);

        } else {

        }


    } else {

    }
    ImageClass.setImage({ ...images.v8.V8PickingUpAnn_2, partialsToDisplay: [images.v8.V8PickingUpAnn_2.partials.V8PickingUpAnn_2_p] });
    if (Question.globalAnswers.v8AnnDateTouchedHerAss) {
        mc.talk(`Now we can go.`);

    } else {
        mc.talk(`Are you ready to go?`);

    }
    ImageClass.setImage(images.v8.V8PickingUpAnn_2);
    ann.talk(`Of course! Are we walking?`);
    ImageClass.setImage({ ...images.v8.V8PickingUpAnn_2, partialsToDisplay: [images.v8.V8PickingUpAnn_2.partials.V8PickingUpAnn_2_p] });
    mc.talk(`Yes, I hope that's not a problem.`);
    ImageClass.setImage(images.v8.V8PickingUpAnn_2);
    ann.talk(`Hehe, not at all! I like going for walks.`);

    ImageClass.setImage({ ...images.v8.V8PickingUpAnn_2, partialsToDisplay: [images.v8.V8PickingUpAnn_2.partials.V8PickingUpAnn_2_p] });
    mc.talk(`Great. Let's head out.`);
    return jump(V8AnnDate_Arrived, "V8AnnDate_Arrived");
};

export const V8AnnDate_Arrived = async (): Promise<any> => {
    doTransition(images.v8.V8AnnDate_0);
    mc.talk(`Here we are!`);
    ImageClass.setImage(images.v8.V8AnnDate_1);
    ann.talk(`I still can't believe it's my first time here.`);
    ImageClass.setImage(images.v8.V8AnnDate_0);
    mc.talk(`I was surprised when you told me that over texts. Why didn't your parents ever take you when you were little?`);
    ImageClass.setImage(images.v8.V8AnnDate_1);
    ann.talk(`I honestly don't know!`);
    ann.talk(`We usually went on road trips.`);
    ImageClass.setImage(images.v8.V8AnnDate_0);
    mc.talk(`I was afraid you'd think we were a bit too old to do this kind of stuff.`);
    ImageClass.setImage(images.v8.V8AnnDate_1);
    ann.talk(`No! It's great! I'm so excited!`);
    ImageClass.setImage(images.v8.V8AnnDate_2);
    ann.talk(`Wow! Look at the height of that thing!`);
    ann.talk(`I've never been on one! I hope it's safe! Hehe.`);
    mc.talk(`I'm sure they won't let us die.`);
    mc.talk(`I hope...`);
    ImageClass.setImage(images.v8.V8AnnDate_3);
    ann.talk(`${mc.name}!`);
    mc.talk(`Haha, relax I'm joking.`);
    ImageClass.setImage(images.v8.V8AnnDate_0);
    mc.talk(`Anyway, I hope you like it here, there aren't many rides...`);
    ImageClass.setImage(images.v8.V8AnnDate_1);
    ann.talk(`I don't care as long as I'm with you!`);
    ann.talk(`Alright! Let's go!`);


    return jump(V8AnnDate_Cashier, "V8AnnDate_Cashier");
};
export const V8AnnDate_Cashier = async (): Promise<any> => {
    doWaitImageByTime(images.v8.V8AnnDate_21);
    mc.talk(`Which ride do you wanna go on first?`);
    ann.talk(`Obviously the Ferris wheel! It looks so impressive.`);
    mc.talk(`Fine by me! Let's get some tickets.`);

    doWaitImageByTime(images.v8.V8AnnDate_22);

    await ann.talk(`Hello! We'd like to get on the Ferris wheel!`);
    cashier.name = "Saleswoman";
    cashier.talk(`You and everyone else.`);
    if (ann.properties.isCorrupted) {
        mc.think(`What the fuck? This girl again? Is she working everywhere?`);
        ann.talk(`Hey! I remember you from the cinema! You didn't let me in to see the premier!`);
        if (Question.globalAnswers.v3KeepAnsweringChris) {
            ann.talk(`Jokes on you! I finally managed to get in.`);
            cashier.talk(`I'm happy for you.\nIs there anything I can help you with?`);

        } else {
            cashier.talk(`That's great.\nIs there anything I can help you with?`);

        }
        mc.talk(`Can we go for a ride?`);

    } else {
        mc.think(`Isn't that the rude saleswoman from the clothing store?`);
        ann.talk(`Ah...`);
        ImageClass.setImage(images.v8.V8AnnDate_22.partials.V8AnnDate_23_p);
        mc.talk(`Lady! I remember you from the clothing store, you better fix your attitude right now.`);
        ImageClass.setImage(images.v8.V8AnnDate_22.partials.V8AnnDate_24_p);
        cashier.talk(`Why are you following me?`);
        ImageClass.setImage(images.v8.V8AnnDate_22.partials.V8AnnDate_23_p);
        mc.talk(`I'm not following you.`);
        mc.talk(`Can we get on the ride now?`);
    }

    ImageClass.setImage(images.v8.V8AnnDate_22.partials.V8AnnDate_24_p);
    cashier.talk(`Yes. Just get inside the cabin.`);
    ImageClass.setImage(images.v8.V8AnnDate_22.partials.V8AnnDate_23_p);
    mc.talk(`Do we need to pay? Or...?`);
    ImageClass.setImage(images.v8.V8AnnDate_22.partials.V8AnnDate_24_p);
    cashier.talk(`Are you serious?`);
    ImageClass.setImage(images.v8.V8AnnDate_22.partials.V8AnnDate_23_p);
    mc.talk(`...`);
    ImageClass.setImage(images.v8.V8AnnDate_22.partials.V8AnnDate_24_p);
    cashier.talk(`Don't play dumb! You obviously came here because of the advertisement.`);
    ImageClass.setImage(images.v8.V8AnnDate_22.partials.V8AnnDate_23_p);
    mc.talk(`Lady, I have no idea what you are talking about.`);
    ImageClass.setImage(images.v8.V8AnnDate_22.partials.V8AnnDate_24_p);
    cashier.talk(`Apparently the owner thought it's a good idea to have a week of free rides to try to increase the popularity of this place.`);
    cashier.talk(`It's usually a ghost town... But tell people it's free and they start shuffling in like zombies.`);
    ImageClass.setImage(images.v8.V8AnnDate_22.partials.V8AnnDate_23_p);
    mc.talk(`Sounds about right...`);
    ImageClass.setImage(images.v8.V8AnnDate_22.partials.V8AnnDate_24_p);
    cashier.talk(`And I don't fucking understand why he told me to come here! People aren't paying!`);

    if (Question.globalAnswers.v6EmilyShoppingAngryAtCashier) {
        mc.talk(`Lady, I'm not your therapist.`);

    } else {
        ImageClass.setImage(images.v8.V8AnnDate_22.partials.V8AnnDate_23_p);
        mc.talk(`Well... It seems like you should have a talk with the owner.`);
        ImageClass.setImage(images.v8.V8AnnDate_22.partials.V8AnnDate_24_p);
        cashier.talk(`No shit Sherlock!`);
        mc.talk(`...`);
    }
    ImageClass.setImage(images.v8.V8AnnDate_22);
    ann.talk(`We are going to get on the ride now...`);

    return jump(V8AnnDate_OnRide, "V8AnnDate_OnRide");
};
export const V8AnnDate_OnRide = async (): Promise<any> => {
    doWaitImageByTime(images.v8.V8AnnDate_25);
    ann.talk(`We are so lucky! Hehe.`);
    if (ann.properties.isCorrupted) {
        await stranger.set((properties) => {
            stranger.name = "Some Dude";
        });
        await strangerTwo.set((properties) => {
            strangerTwo.name = "Another Dude";
        });
        doWaitImageByTime(images.v8.V8AnnDateCorrupted_82);
        mc.think(`Damn that ass!`);
        if (Question.globalAnswers.v1EnableNTR) {
            ImageClass.setImage(images.v8.V8AnnDateCorrupted_83);
            mc.think(`I'm not the only one who noticed it.`);
            ImageClass.setImage(images.v8.V8AnnDateCorrupted_84);
            stranger.talk(`Bro!`);
            strangerTwo.talk(`...`);
            ImageClass.setImage(images.v8.V8AnnDateCorrupted_85);
            stranger.talk(`Bro!!!`);
            strangerTwo.talk(`What?!`);
            ImageClass.setImage(images.v8.V8AnnDateCorrupted_86);
            stranger.talk(`Check this out.`);
            ImageClass.setImage(images.v8.V8AnnDateCorrupted_87);
            strangerTwo.talk(`Sweet!`);
            mc.think(`I don't think Ann heard or noticed them.`);
        } else {
        }

    } else {

    }

    if (ann.properties.isCorrupted) {
        doWaitImageByTime({ ...images.v8.V8AnnDate_26, partialsToDisplay: [images.v8.V8AnnDate_26.partials.V8AnnDate_26_p_2] });
        ann.talk(`I can't believe that cashier has two jobs.`);
        ImageClass.setImage(images.v8.V8AnnDate_26.partials.V8AnnDate_26_p);
        mc.talk(`Make it three.`);
        ImageClass.setImage(images.v8.V8AnnDate_26.partials.V8AnnDate_26_p_2);
        ann.talk(`Seriously?`);

    } else {
        doWaitImageByTime(images.v8.V8AnnDate_26);

        if (Question.globalAnswers.v6EmilyShoppingAngryAtCashier) {
            ann.talk(`I can't believe you said that to her!`);
            mc.talk(`We have history...`);

        } else {
            ann.talk(`She was nice!`);
            mc.talk(`Not really...`);
        }
    }
    ImageClass.setImage({ ...images.v8.V8AnnDate_26, partialsToDisplay: [images.v8.V8AnnDate_26.partials.V8AnnDate_26_p] });
    mc.talk(`Do you remember the outfit Vanessa made you wear?`);
    ImageClass.setImage(images.v8.V8AnnDate_26.partials.V8AnnDate_26_p_2);
    ann.talk(`How could I forget?`);
    ImageClass.setImage(images.v8.V8AnnDate_26.partials.V8AnnDate_26_p);
    mc.talk(`So that girl was the saleswoman at that store...`);
    mc.talk(`She couldn't take her eyes off her phone... And like you can see... She is a real people person.`);
    ImageClass.setImage(images.v8.V8AnnDate_26.partials.V8AnnDate_26_p_2);
    ann.talk(`Yeah...`);
    ImageClass.setImage(images.v8.V8AnnDate_26);
    ann.talk(`How can you even be in a bad mood when working in a place like this? Hehe.`);
    ImageClass.setImage(images.v8.V8AnnDate_26.partials.V8AnnDate_26_p);
    mc.talk(`You really like this place, huh?`);
    ImageClass.setImage(images.v8.V8AnnDate_26.partials.V8AnnDate_26_p_2);
    ann.talk(`Of course!`);
    ImageClass.setImage(images.v8.V8AnnDate_26);

    ann.talk(`Why aren't we moving by the way?`);
    ImageClass.setImage(images.v8.V8AnnDate_26.partials.V8AnnDate_26_p);
    mc.talk(`It's normal. They let every cabin enjoy the top for about ten minutes before rotating.`);
    ann.talk(`Oh... I feel so stupid for not knowing that.`);
    mc.talk(`Now you know.`);
    ann.talk(`Hehe.`);
    doWaitImageByTime(images.v8.V8AnnDate_28);
    ann.talk(`Hey! We are moving!`);
    ImageClass.setImage(images.v8.V8AnnDate_27);
    ann.talk(`Wow, we are not even close to the top and I can already see my house from here!`);
    mc.talk(`Is it your first time being this high up?`);
    ImageClass.setImage({ ...images.v8.V8AnnDate_28, partialsToDisplay: [images.v8.V8AnnDate_28.partials.V8AnnDate_28_p] });
    ann.talk(`Yes!`);
    ImageClass.setImage(images.v8.V8AnnDate_28.partials.V8AnnDate_28_p_2);
    ann.talk(`As I said, we usually went on road trips and never to the mountains... Hehe.`);
    ImageClass.setImage(images.v8.V8AnnDate_28);
    mc.talk(`I'm glad I'm here to see you enjoy it.`);
    ImageClass.setImage(images.v8.V8AnnDate_28.partials.V8AnnDate_28_p);
    ann.talk(`Hehe.`);

    if (ann.properties.isCorrupted) {
        mc.talk(`Oh! I just remembered!`);

    } else {

        ImageClass.setImage(images.v8.V8AnnDate_27);
        mc.talk(`Since we have time, do you want to talk about what you mentioned over the phone?`);
        ImageClass.setImage({ ...images.v8.V8AnnDate_28, partialsToDisplay: [images.v8.V8AnnDate_28.partials.V8AnnDate_28_p_3] });
        ann.talk(`Yeah... Right.`);
        ImageClass.setImage(images.v8.V8AnnDate_28.partials.V8AnnDate_28_p_4);
        ann.talk(`Well... So... Remember our talk yesterday?`);
        ImageClass.setImage(images.v8.V8AnnDate_28.partials.V8AnnDate_28_p_5);
        mc.talk(`I do.`);
        ImageClass.setImage(images.v8.V8AnnDate_28.partials.V8AnnDate_28_p_4);
        ann.talk(`So apparently I'd be leaving to take those exams I was talking about in two days.`);
        ann.talk(`But I'm not going to be gone long!`);
        ImageClass.setImage({ ...images.v8.V8AnnDate_28, partialsToDisplay: [images.v8.V8AnnDate_28.partials.V8AnnDate_28_p_2] });

        ann.talk(`And that's why I said coming here is perfect.`);
        ImageClass.setImage(images.v8.V8AnnDate_28.partials.V8AnnDate_28_p_3);
        ann.talk(`And... I was also thinking about something else...`);
        ImageClass.setImage(images.v8.V8AnnDate_28.partials.V8AnnDate_28_p_4);
        ann.talk(`I know I haven't had much time lately...`);

        ImageClass.setImage(images.v8.V8AnnDate_28.partials.V8AnnDate_28_p_3);
        ann.talk(`And I was wondering if we could do what we did the other day... You know... In your room.`);
        if (mc.properties.alpha > 7) {
            ImageClass.setImage(images.v8.V8AnnDate_28.partials.V8AnnDate_28_p_5);
            mc.talk(`You can say you want to have sex.`);
            ImageClass.setImage(images.v8.V8AnnDate_28.partials.V8AnnDate_28_p_3);
            ann.talk(`You know it's not easy for me to talk about these things...`);

        } else {

        }
        ImageClass.setImage(images.v8.V8AnnDate_28.partials.V8AnnDate_28_p_3);
        ann.talk(`So I was thinking... Maybe we can continue this date and do something special after we leave here.`);
        ImageClass.setImage(images.v8.V8AnnDate_28.partials.V8AnnDate_28_p_5);
        mc.talk(`I would love that.`);
        ImageClass.setImage({ ...images.v8.V8AnnDate_28, partialsToDisplay: [images.v8.V8AnnDate_28.partials.V8AnnDate_28_p_2] });
        ann.talk(`You would???`);
        mc.talk(`Of course!`);
        ImageClass.setImage(images.v8.V8AnnDate_28);
        mc.talk(`Oh. Fuck! I almost forgot.`);
        doPutMultipleImages([images.v8.V8AnnDate_28, images.v8.V8AnnDate_28.partials.V8AnnDate_28_p_3, images.v8.V8AnnDate_28.partials.V8AnnDate_28_p_6]);
    }

    mc.talk(`My ${emily.properties.relation} wants to meet you... I promised her that I'd ask you.`);
    doPutMultipleImages([images.v8.V8AnnDate_28, images.v8.V8AnnDate_28.partials.V8AnnDate_28_p_3, images.v8.V8AnnDate_28.partials.V8AnnDate_28_p_7]);
    ann.talk(`Meet me...?`);

    if (ann.properties.isCorrupted) {
        if (Question.globalAnswers.v5TouchedAnnInLivingRoom) {
            mc.talk(`Yeah. She just saw you for a second the other day.`);
            ImageClass.setImage({ ...images.v8.V8AnnDate_28, partialsToDisplay: [images.v8.V8AnnDate_28.partials.V8AnnDate_28_p_3] });
            ann.talk(`I remember... That was... A bit...`);
            doWaitImageByTime(images.v8.V8AnnDate_28.partials.V8AnnDate_28_p_4);
            ann.talk(`Embarrassing.`);
            ImageClass.setImage(images.v8.V8AnnDate_28.partials.V8AnnDate_28_p_5);
            mc.talk(`Nah, don't think much of it!`);
            ImageClass.setImage(images.v8.V8AnnDate_28.partials.V8AnnDate_28_p_6);
            mc.talk(`Anyway, she wants to meet you.`);
            doPutMultipleImages([images.v8.V8AnnDate_28, images.v8.V8AnnDate_28.partials.V8AnnDate_28_p_3, images.v8.V8AnnDate_28.partials.V8AnnDate_28_p_7]);

        } else {

            ImageClass.setImage(images.v8.V8AnnDate_28.partials.V8AnnDate_28_p_6);
            mc.talk(`Yeah. She just saw you for a second the other day.`);
            ImageClass.setImage(images.v8.V8AnnDate_28);
            mc.talk(`Remember? Before we tried to get into the premier?`);
            ImageClass.setImage(images.v8.V8AnnDate_28.partials.V8AnnDate_28_p);
            ann.talk(`Yeah, of course I remember!`);
            ImageClass.setImage(images.v8.V8AnnDate_28);
            mc.talk(`Anyway, she wants to meet you.`);
            ImageClass.setImage(images.v8.V8AnnDate_28.partials.V8AnnDate_28_p_2);
        }
        ann.talk(`Well, I don't mind.`);
        ImageClass.setImage({ ...images.v8.V8AnnDate_28, partialsToDisplay: [images.v8.V8AnnDate_28.partials.V8AnnDate_28_p_2] });

        ann.talk(`When does she wants to meet?`);
        ImageClass.setImage(images.v8.V8AnnDate_28);
        mc.talk(`Tonight. She arranged a movie and everything.`);
        ImageClass.setImage(images.v8.V8AnnDate_28.partials.V8AnnDate_28_p_3);
        ann.talk(`Oh... That brings me to what we talked about over the phone.`);
        ImageClass.setImage(images.v8.V8AnnDate_28.partials.V8AnnDate_28_p_4);
        ann.talk(`I wanted to asked you to practice some acting with me.`);
        ann.talk(`Or at least tell me what I should do...`);
        ann.talk(`I tried doing it in front of the mirror but I'm having hard time stay in focused.`);
        ann.talk(`But I guess we don't have the time now if we'll meet with your ${emily.properties.relation}.`);
        ImageClass.setImage(images.v8.V8AnnDate_28.partials.V8AnnDate_28_p_5);

        mc.talk(`Of course, we'll have time!`);
        ImageClass.setImage(images.v8.V8AnnDate_28.partials.V8AnnDate_28_p_6);
        mc.talk(`It's still early, once we'll wrap up here we'll have plenty of time to do both!`);

        ImageClass.setImage(images.v8.V8AnnDate_28.partials.V8AnnDate_28_p_2, { putParent: true });
        ann.talk(`Hehe! That works!`);
        ImageClass.setImage(images.v8.V8AnnDate_28);
        mc.talk(`Perfect!`);

    } else {

        doPutMultipleImages([images.v8.V8AnnDate_28, images.v8.V8AnnDate_28.partials.V8AnnDate_28_p_3, images.v8.V8AnnDate_28.partials.V8AnnDate_28_p_6]);
        mc.talk(`Yes... She wants to fix your first impression of her... She has a feeling she scared you a bit.`);
        ImageClass.setImage(images.v8.V8AnnDate_28.partials.V8AnnDate_28_p_7);
        ann.talk(`Not scared... Just surprised, that's all.`);
        doPutMultipleImages([images.v8.V8AnnDate_28, images.v8.V8AnnDate_28.partials.V8AnnDate_28_p_3, images.v8.V8AnnDate_28.partials.V8AnnDate_28_p_6]);
        mc.talk(`Nevermind. It's not a good idea. I'll make some excuse why you couldn't come.`);
        ImageClass.setImage(images.v8.V8AnnDate_28.partials.V8AnnDate_28_p_7);
        ann.talk(`No! Don't do that.`);
        ImageClass.setImage({ ...images.v8.V8AnnDate_28, partialsToDisplay: [images.v8.V8AnnDate_28.partials.V8AnnDate_28_p_3, images.v8.V8AnnDate_28.partials.V8AnnDate_28_p_4] });
        ann.talk(`Don't forget we have an extra day!`);
        ImageClass.setImage(images.v8.V8AnnDate_28.partials.V8AnnDate_28_p_5);
        mc.talk(`Are you sure?`);
        ImageClass.setImage({ ...images.v8.V8AnnDate_28, partialsToDisplay: [images.v8.V8AnnDate_28.partials.V8AnnDate_28_p_2] });
        ann.talk(`Yes. Tonight I'll meet your ${emily.properties.relation}, and tomorrow we'll do a special night just the two of us.`);
        ImageClass.setImage(images.v8.V8AnnDate_28);
        mc.talk(`Sounds perfect!`);

    }
    ImageClass.setImage(images.v8.V8AnnDate_28.partials.V8AnnDate_28_p);
    ann.talk(`Hehe.`);


    return jump(V8AnnDate_OnRideTop, "V8AnnDate_OnRideTop");
};
export const V8AnnDate_OnRideTop = async (): Promise<any> => {
    doTransition(images.v8.V8AnnDate_4);
    mc.talk(`We are finally at the top!`);
    ann.talk(`I can see that...`);
    mc.talk(`You don't look pleased...`);
    ImageClass.setImage({ ...images.v8.V8AnnDate_4.partials.V8AnnDate_5, partialsToDisplay: [images.v8.V8AnnDate_4.partials.V8AnnDate_5_p] });
    ann.talk(`${mc.name}?`);
    doWaitImageByTime(images.v8.V8AnnDate_4.partials.V8AnnDate_5, { putParent: true });
    mc.talk(`Yes?`);
    ImageClass.setImage(images.v8.V8AnnDate_4.partials.V8AnnDate_5_p);
    ann.talk(`I think I might have a fear of heights...`);
    ImageClass.setImage(images.v8.V8AnnDate_4.partials.V8AnnDate_5, { putParent: true });
    mc.talk(`Really?`);
    ImageClass.setImage(images.v8.V8AnnDate_4.partials.V8AnnDate_5_p);
    ann.talk(`Almost positive... I've never been this high...`);
    ImageClass.setImage(images.v8.V8AnnDate_4.partials.V8AnnDate_5, { putParent: true });
    mc.talk(`Just relax and breathe, we'll be down in no time.`);
    ImageClass.setImage(images.v8.V8AnnDate_4.partials.V8AnnDate_5_p);
    ann.talk(`Maybe I'm just overreacting and it's not that high...`);
    ann.talk(`Let me check...`);
    doWaitImageByTime(images.v8.V8AnnDate_6);
    mc.talk(`So?`);
    ImageClass.setImage(images.v8.V8AnnDate_7);
    ann.talk(`AH!!!`);
    ImageClass.setImage(images.v8.V8AnnDate_8);
    ann.talk(`It's confirmed! I definitely have a fear of heights...`);
    ann.talk(`Looking down was a bad idea...`);
    mc.talk(`Ann.`);
    ann.talk(`Yes?`);
    mc.talk(`Look at me.`);

    doWaitImageByTime(images.v8.V8AnnDate_9);
    ann.talk(`...`);
    mc.talk(`It will be fine! We'll be down in no time.`);
    ImageClass.setImage(images.v8.V8AnnDate_9.partials.V8AnnDate_9_p);
    ann.talk(`Promise?`);
    ImageClass.setImage(images.v8.V8AnnDate_9);
    mc.talk(`Promise.`);
    mc.talk(`Come here, I'll keep you safe.`);
    doWaitImageByTime(images.v8.V8AnnDate_10);
    mc.talk(`How's that feel?`);
    ann.talk(`It feels good.`);
    mc.talk(`Turn around and don't look down. Just look at me.`);
    doWaitImageByTime({ ...images.v8.V8AnnDate_11, partialsToDisplay: [images.v8.V8AnnDate_11.partials.V8AnnDate_11_p] });
    ann.talk(`Hehe.`);
    ImageClass.setImage(images.v8.V8AnnDate_11);
    mc.talk(`Feeling better?`);
    ImageClass.setImage(images.v8.V8AnnDate_11.partials.V8AnnDate_11_p);
    ann.talk(`As long as I stay on the floor and don't look down... Hehe.`);
    ImageClass.setImage(images.v8.V8AnnDate_11);
    let text = '';
    // TODO: Ann corruption
    if (!ann.properties.isCorrupted) {
        await mc.setQuestion(new Question({ text: `Since she is down there already... And I'm a bit horny... Maybe we can have some fun.`, options: { think: true }, key: `V8AnnDatePulledDickOut` })
            .option({ title: `Pull your dick out`, info: text, key: true })
            .option({ title: `Don't do it`, key: false }));
    }



    if (Question.globalAnswers.V8AnnDatePulledDickOut) {
        return jump(V8AnnDate_OnRideTop_PulledDickOut, "V8AnnDate_OnRideTop_PulledDickOut");
    }

    jump(V8AnnDate_OnRideTop_DidntPullDickOut, "V8AnnDate_OnRideTop_DidntPullDickOut");
};

export const V8AnnDate_OnRideTop_PulledDickOut = async (): Promise<any> => {
    doWaitImageByTime(images.v8.V8AnnDate_14);
    if (mc.properties.alpha > 7) {
        mc.talk(`I know how to keep you distracted.`);

    } else {
        mc.talk(`I know how we can pass the time...`);

    }
    await ann.set((properties) => {
        properties.corruption++;
    });
    ImageClass.setImage(images.v8.V8AnnDate_15);
    ann.talk(`${mc.name}! What are you doing?!`);
    mc.talk(`Distracting you.`);
    ImageClass.setImage(images.v8.V8AnnDate_16);
    ann.talk(`People might see you!`);
    mc.talk(`We are at the highest point... No one can see us.`);
    ImageClass.setImage(images.v8.V8AnnDate_14);
    mc.talk(`Come on. Grab it...`);
    ImageClass.setImage(images.v8.V8AnnDate_15);
    ann.talk(`Are you sure about it?`);
    mc.talk(`Most definitely.`);
    ImageClass.setImage(images.v8.V8AnnDate_17);
    ann.talk(`Hehe. You are so silly.`);
    ann.talk(`I can't believe I'm actually doing this! Hehe.`);
    mc.talk(`It has been some time since you last did it. I've missed your touch.`);
    ImageClass.setImage(images.v8.Anim_AnnFerrisWheelHJ.poster);
    mc.talk(`Just stroke it for a bit.`);
    ImageClass.setAnimation(images.v8.Anim_AnnFerrisWheelHJ, { duration: 0, wait: true });
    mc.think(`That feels good...`);
    ImageClass.setImage(images.v8.Anim_AnnFerrisWheelBJ.poster, { wait: 1, duration: 1 });
    ImageClass.setAnimation(images.v8.Anim_AnnFerrisWheelBJ, { duration: 0 });
    mc.think(`Now we are talking!`);
    mc.talk(`Yes... Keep going...`);
    ann.talk(`Mmm...`);
    ImageClass.setAnimation(images.v8.Anim_AnnFerrisWheelCum, { duration: 0, loop: 0 });
    mc.talk(`Ahh!!!`);
    ImageClass.setImage(images.v8.V8AnnDate_73);
    ann.talk(`Mmm!!!`);
    ImageClass.setImage(images.v8.V8AnnDate_74);

    await ann.setQuestion(new Question({ text: `Ah...`, options: { think: false }, key: `v8AnnDateSwallowCum` })
        .option({ title: `Swallow it`, key: true })
        .option({ title: `You can spit it out`, key: false }));


    if (Question.globalAnswers.v8AnnDateSwallowCum) {
        mc.talk(`Swallow it.`);
        ImageClass.setImage(images.v8.V8AnnDate_75, { wait: true });
        ImageClass.setImage(images.v8.V8AnnDate_76);
        ann.talk(`I did it!`);
        mc.talk(`Show me.`);
        ImageClass.setImage(images.v8.V8AnnDate_77);
        ann.talk(`Ahh...`);
        mc.talk(`How was it?`);
        ImageClass.setImage(images.v8.V8AnnDate_76);
        if (Question.globalAnswers.v4ToldAnnToSwallowAfterCum) {
            ann.talk(`Hehe... Getting better... It's not my first time you know. Hehe.`);

        } else {
            ann.talk(`Not bad at all... Hehe.`);
        }


    } else {
        mc.talk(`You can spit it out.`);
        ImageClass.setImage(images.v8.V8AnnDate_78);
        ann.talk(`Ptui!`);
        ImageClass.setImage(images.v8.V8AnnDate_79);
        ann.talk(`Oh my... I hope people won't notice it.`);
        ImageClass.setImage(images.v8.V8AnnDate_79.partials.V8AnnDate_79_p);
        mc.talk(`Don't worry... It will dry out in no time.`);
        ImageClass.setImage(images.v8.V8AnnDate_79);
        ann.talk(`Are you sure?`);
        mc.talk(`Of course.`);
        ImageClass.setImage(images.v8.V8AnnDate_79.partials.V8AnnDate_79_p_2);
        ann.talk(`Hehe. Good! It could have been very awkward.`);
    }

    mc.talk(`Come, sit next to me.`);
    await endReplay(replayScenesList.v8AnnDateBJFerris);

    if (Question.globalAnswers.v8AnnDateSwallowCum) {
        ImageClass.setImage(images.v8.V8AnnDate_76);
    } else {
        ImageClass.setImage(images.v8.V8AnnDate_79);
        ann.talk(`Are you... sure? I might get scared.`);
        ImageClass.setImage(images.v8.V8AnnDate_79.partials.V8AnnDate_79_p);
        mc.talk(`Don't worry. I'll keep you safe.`);
        ImageClass.setImage(images.v8.V8AnnDate_79.partials.V8AnnDate_79_p_2);
    }

    ann.talk(`Hehe, ok!`);




    return jump(V8AnnDate_OnRideTop_2, "V8AnnDate_OnRideTop_2");
};

export const V8AnnDate_OnRideTop_DidntPullDickOut = async (): Promise<any> => {
    mc.talk(`Don't stay on the floor.`);
    mc.talk(`Come. Sit next to me. I'll keep you safe.`);
    ann.talk(`Ok... But I'm getting back down if I get scared again.`);
    mc.talk(`Deal.`);
    // TODO: render Chris conversation renders expressions
    doWaitImageByTime(images.v8.V8AnnDate_12);
    mc.talk(`Isn't this better than the floor?`);
    ann.talk(`Hehe. It is.`);
    ann.talk(`I hope I didn't ruin the mood.`);
    mc.talk(`Of course not.`);
    ImageClass.setImage(images.v8.V8AnnDate_13);
    mc.talk(`Muah!`);
    ann.talk(`Muah!`);


    return jump(V8AnnDate_OnRideTop_2, "V8AnnDate_OnRideTop_2");
};

export const V8AnnDate_OnRideTop_2 = async (): Promise<any> => {
    if (Question.globalAnswers.v3KeepAnsweringChris) {
        return jump(V8AnnDate_OnRideTop_AskAboutChris, "V8AnnDate_OnRideTop_AskAboutChris");

    }


    return jump(V8AnnDate_OnRideTop_NoChris, "V8AnnDate_OnRideTop_NoChris");
};


export const V8AnnDate_OnRideTop_NoChris = async (): Promise<any> => {

    return jump(V8AnnDate_OnRideTop_3, "V8AnnDate_OnRideTop_3");
};


export const V8AnnDate_OnRideTop_AskAboutChris = async (): Promise<any> => {
    mc.think(`Now is a good time to ask about Chris...`);
    ImageClass.setImage(images.v8.V8AnnDate_70);
    mc.talk(`There is something I would like to ask you.`);
    ImageClass.setImage(images.v8.V8AnnDate_70.partials.V8AnnDate_70_p);
    ann.talk(`Anything that distracts me would be appreciated, hehe.`);
    ImageClass.setImage(images.v8.V8AnnDate_70);
    mc.talk(`Before picking you up, I paid Vanessa a visit.`);
    mc.talk(`She wanted to know what I think about you and Chris.`);
    ImageClass.setImage(images.v8.V8AnnDate_70.partials.V8AnnDate_70_p_2);
    ann.talk(`And what did you say?`);
    ImageClass.setImage(images.v8.V8AnnDate_70.partials.V8AnnDate_70_p_3);
    mc.talk(`Well, I would like to hear from you first.`);
    mc.talk(`What is he to you?`);
    ImageClass.setImage(images.v8.V8AnnDate_70.partials.V8AnnDate_70_p_4);
    ann.talk(`Ah...`);
    ImageClass.setImage({ ...images.v8.V8AnnDate_70, partialsToDisplay: [images.v8.V8AnnDate_70.partials.V8AnnDate_70_p_2] });
    ann.talk(`He is a... friend.`);
    ImageClass.setImage(images.v8.V8AnnDate_70.partials.V8AnnDate_70_p_3);
    mc.talk(`Like me?`);
    ImageClass.setImage(images.v8.V8AnnDate_70.partials.V8AnnDate_70_p_4);
    ann.talk(`Maybe he is more than a friend...`);
    ann.talk(`At first I really thought he was just a friend...`);
    ImageClass.setImage({ ...images.v8.V8AnnDate_70, partialsToDisplay: [images.v8.V8AnnDate_70.partials.V8AnnDate_70_p_2] });
    ann.talk(`But I guess I should've known... Who would ask for a girl's phone number just to be her friend...`);
    ann.talk(`But things got cleared up right away, and that's when I asked you if I should keep talking to him, and you said yes... So I did.`);

    ImageClass.setImage(images.v8.V8AnnDate_70.partials.V8AnnDate_70_p_4);
    ann.talk(`Now that I say it out loud I understand how weird it seems...`);
    ann.talk(`By the way, he knows about you.`);
    ImageClass.setImage({ ...images.v8.V8AnnDate_70, partialsToDisplay: [images.v8.V8AnnDate_70.partials.V8AnnDate_70_p_2] });
    ann.talk(`He knows that you are my boyfriend...`);

    ImageClass.setImage({ ...images.v8.V8AnnDate_70, partialsToDisplay: [images.v8.V8AnnDate_70.partials.V8AnnDate_70_p] });
    ann.talk(`And in fact he had told me he wants to get to know you better.`);
    if (Question.globalAnswers.v4NoJoeyWasMeanToChris && !Question.globalAnswers.v7JennyDateApologizedToChris) {
        ImageClass.setImage({ ...images.v8.V8AnnDate_70, partialsToDisplay: [images.v8.V8AnnDate_70.partials.V8AnnDate_70_p_3] });
        mc.talk(`Are you sure?`);
        mc.talk(`We aren't on the best terms since Joey's birthday party`);
        ImageClass.setImage({ ...images.v8.V8AnnDate_70, partialsToDisplay: [images.v8.V8AnnDate_70.partials.V8AnnDate_70_p] });
        ann.talk(`I'm positive! That's what he said!`);
    }
    ImageClass.setImage({ ...images.v8.V8AnnDate_70, partialsToDisplay: [images.v8.V8AnnDate_70.partials.V8AnnDate_70_p_3] });
    mc.talk(`So Emily wants to get to know you better and Chris wants to get to know me better...`);
    ImageClass.setImage({ ...images.v8.V8AnnDate_70, partialsToDisplay: [images.v8.V8AnnDate_70.partials.V8AnnDate_70_p] });
    ann.talk(`Hehe, so it's only fair you'd agree!`);
    ann.talk(`Just think about that!`);


    ImageClass.setImage(images.v8.V8AnnDate_70.partials.V8AnnDate_70_p_3);
    await ann.setQuestion(new Question({ text: `I just hope you are really okay with me seeing him...`, options: { think: false }, key: `V8AnnDateMCOkWithChris` })
        .option({ title: `I'm ok with that`, key: true })
        .option({ title: `Stop seeing him`, key: false }));


    // TODO: remind the bar conversation with chris/MC
    if (Question.globalAnswers.V8AnnDateMCOkWithChris) {
        mc.talk(`I'm ok with that.`);
        ImageClass.setImage(images.v8.V8AnnDate_70.partials.V8AnnDate_70_p);
        ann.talk(`You are??? I'm so glad!`);
        ann.talk(`My heart is beating so fast...`);
        ann.talk(`I was scared you'd tell me to stop seeing him...`);
        ImageClass.setImage(images.v8.V8AnnDate_70);
        mc.talk(`That would be selfish... As you said, I'm the one who told you to keep talking to him in the first place.`);
    } else {
        mc.talk(`Stop seeing him.`);
        ImageClass.setImage(images.v8.V8AnnDate_70.partials.V8AnnDate_70_p_5);
        ann.talk(`What?! Are you serious?`);
        ImageClass.setImage(images.v8.V8AnnDate_70.partials.V8AnnDate_70_p_6);
        mc.talk(`I am.`);
        mc.talk(`Obviously it's gone too far.`);
        ImageClass.setImage(images.v8.V8AnnDate_70.partials.V8AnnDate_70_p_5);
        ann.talk(`That's not fair! Why did you tell me to keep talking to him in the first place?!`);
        ann.talk(`He is a really good... friend of mine at this point...`);
        mc.talk(`So you'd rather hurt me instead of him?`);
        ImageClass.setImage(images.v8.V8AnnDate_70.partials.V8AnnDate_70_p_7);
        ann.talk(`...`);
        ann.talk(`You are right... Talking with him was stupid of me...`);
        ann.talk(`I'll talk to him...`);

        ann.talk(`Can we just pretend this conversation didn't happen?`);
        ann.talk(`I don't want it to ruin our special day...`);
        mc.talk(`Of course.`);
    }
    // TODO: do text transition for flashing guys.

    return jump(V8AnnDate_OnRideTop_3, "V8AnnDate_OnRideTop_3");
};
export const V8AnnDate_OnRideTop_3 = async (): Promise<any> => {
    if (Question.globalAnswers.v1EnableNTR && ann.properties.isCorrupted) {
        ImageClass.setImage(images.v8.V8AnnDateCorrupted_88);
        if (Question.globalAnswers.V8AnnDateMCOkWithChris !== undefined) {
            mc.talk(`I have an idea on how to distract you`);
            ann.talk(`Hehe, what?`);
        } else {
            ann.talk(`We are at the top... What now?`);
            ann.talk(`I can't really look down.`);
            ann.talk(`Can you think of something fun we can do?`);
        }
        // ann.talk(`I refuse to believe I have a fear of heights!`);
        // mc.talk(`Don't think much of it. A lot of people suffer from it.`);
        // ann.talk(`But I don't want to be a statistic!`);
        // mc.talk(`You know, adrenalin can help. Though it's just a temporary solution.`);
        if (Question.globalAnswers.V8AnnDatePulledDickOut) {
            // ann.talk(`Well... I was really distracted just a few moments ago... Hehe.`);
            // mc.talk(`You see.`);
            // ann.talk(`Hehe! No way, my mouth is exhausted`);

        } else {
        }
        await mc.setQuestion(new Question({ text: `Those two guys really liked Ann... Maybe I can convince her to flash them.`, options: { think: true }, key: `v8AnnDateFlashGuys` })
            .option({ title: `Convince Ann to flash them`, key: true })
            .option({ title: `Don't convince`, key: false }));


        if (Question.globalAnswers.v8AnnDateFlashGuys) {
            ImageClass.setImage(images.v8.V8AnnDateCorrupted_89);
            mc.talk(`Mmm... I have an idea.`);
            ann.talk(`Yes?`);
            mc.talk(`Behind you there are two guys.`);
            mc.talk(`Don't look straight down. They are just on the next cabin down.`);
            doWaitImageByTime(images.v8.V8AnnDateCorrupted_90);
            ann.talk(`What about them?`);
            mc.talk(`You should flash your boobs at them.`);
            ImageClass.setImage(images.v8.V8AnnDateCorrupted_89);
            ann.talk(`Hehe! What?!`);
            mc.talk(`I'm sure they would appreciate it.`);
            doWaitImageByTime(images.v8.V8AnnDateCorrupted_90);
            ann.talk(`You think?`);
            ann.talk(`I don't think they are not into girls...`);
            ann.talk(`Like... Two guys going to an amusement park together?`);
            mc.talk(`You have a point. But I heard them talking when we got into the cabin.`);
            mc.talk(`They were definitely checking you out.`);
            ann.talk(`Hehe.`);
            doWaitImageByTime(images.v8.V8AnnDateCorrupted_91);
            ann.talk(`I'm gonna do it!`);
            doWaitImageByTime(images.v8.V8AnnDateCorrupted_92);
            mc.think(`Wow, she really went for it!`);
            doWaitImageByTime(images.v8.V8AnnDateCorrupted_93);
            mc.think(`She got their attention.`);
            ImageClass.setImage(images.v8.V8AnnDateCorrupted_94, { wait: true });
            ImageClass.setImage(images.v8.V8AnnDateCorrupted_95, { wait: true });
            ImageClass.setImage(images.v8.V8AnnDateCorrupted_96);
            ann.talk(`Oh my!`);
            ann.talk(`He just took a picture of me!`);
            ann.talk(`He is going to post it all over the internet!`);
            mc.talk(`That will make him a very rich man.`);
            ImageClass.setImage(images.v8.V8AnnDateCorrupted_97);
            ann.talk(`Hehe, stop!`);
            ImageClass.setImage(images.v8.V8AnnDateCorrupted_96);
            mc.talk(`Don't be ashamed of your body.`);
            mc.talk(`You have an amazing body. You should show it off more.`);
            ann.talk(`You are right! I shouldn't hide!`);
            doWaitImageByTime(images.v8.V8AnnDateCorrupted_98);
            mc.talk(`That's the spirit!`);

        } else {
            if (Question.globalAnswers.V8AnnDateMCOkWithChris !== undefined) {
                mc.talk(`Never mind...`);
                ann.talk(`Ok.`);
            } else {

                mc.talk(`Not really... At this point all we can do is wait.`);
                ann.talk(`Ok!`);
            }
        }

    } else {

    }
    // TODO: contunue

    return jump(V8AnnDate_3, "V8AnnDate_3");
};
export const V8AnnDate_3 = async (): Promise<any> => {
    doTransition(images.v8.V8AnnDate_32);
    ann.talk(`Finally down!`);
    ImageClass.setImage(images.v8.V8AnnDate_31);
    mc.talk(`How do you feel now?`);
    ImageClass.setImage(images.v8.V8AnnDate_32);
    ann.talk(`Way better... I'm still shocked I never knew I had a fear of heights.`);
    ann.talk(`But it was fun regardless! Hehe.`);
    ImageClass.setImage(images.v8.V8AnnDate_31);
    mc.talk(`Good to hear!`);
    mc.talk(`Have you seen any other rides you'd like to try?`);
    ImageClass.setImage(images.v8.V8AnnDate_33);
    ann.talk(`Mmm...`);
    ImageClass.setImage(images.v8.V8AnnDate_35);
    if (ann.properties.isCorrupted) {
        ann.talk(`Hey! Look there! You can win prizes!`);
        mc.talk(`Let's go have a look.`);
        return jump(V8AnnDate_Booth, "V8AnnDate_Booth");
    }
    ann.talk(`Hey! look there! A carousel!`);
    mc.talk(`Really...?`);
    ImageClass.setImage(images.v8.V8AnnDate_34);
    ann.talk(`Hehe. Why not?`);
    ann.talk(`You told me to pick so I want to ride that one!`);
    mc.talk(`You are the boss... Let's go have a look.`);

    return jump(V8AnnDate_Carousel, "V8AnnDate_Carousel");
};
export const V8AnnDate_Carousel = async (): Promise<any> => {
    // TODO: skip this on corruption?
    doTransition(images.v8.V8AnnDate_39);
    ann.talk(`So, which horse are you going to pick?`);
    ImageClass.setImage(images.v8.V8AnnDate_36);
    mc.talk(`I think I'll sit this one out.`);
    ImageClass.setImage(images.v8.V8AnnDate_39);
    ann.talk(`Are you sure?`);
    ImageClass.setImage(images.v8.V8AnnDate_36);
    mc.talk(`Yeah, I'm sure...`);
    ImageClass.setImage(images.v8.V8AnnDate_37);
    mc.talk(`Judging by the lack of people I'm not the only one with that same thought...`);
    ImageClass.setImage(images.v8.V8AnnDate_38);
    ann.talk(`Ok... Let's go find something else.`);
    mc.talk(`Don't be silly. Go ahead and ride it. I'll just admire you from here.`);
    ImageClass.setImage(images.v8.V8AnnDate_39);
    ann.talk(`Hehe! Ok!`);

    doWaitImageByTime(images.v8.Anim_AnnTurning.poster);
    ImageClass.setAnimation(images.v8.Anim_AnnTurning, { duration: 0 });
    ann.talk(`Here I go!`);
    // rotating animation
    if (Question.globalAnswers.V8AnnDateMCOkWithChris) {
        mc.think(`She is so cute, I can't believe she's never been here.`);

    } else if (Question.globalAnswers.V8AnnDateMCOkWithChris === false) {
        mc.think(`I'm glad she's having fun, she was a bit upset when I told her to stop seeing Chris.`);
    }

    await empty.set((properties) => {
        properties.tempNum = 1;
    });
    return jump(V8AnnDate_Carousel_2, "V8AnnDate_Carousel_2");
};

export const V8AnnDate_Carousel_2 = async (): Promise<any> => {
    ImageClass.setImage(images.v8.V8AnnDate_36);
    await ann.setQuestion(new Question({ text: `That's it!`, options: { think: false }, key: `V8AnnDateCarouselGoAhead` })
        .option({ title: `Go again`, key: true })
        .option({ title: `That's enough`, key: false }));


    if (Question.globalAnswers.V8AnnDateCarouselGoAhead) {
        if (empty.properties.tempNum === 1) {
            mc.talk(`You should go again.`);
            ImageClass.setImage(images.v8.V8AnnDate_39);
            ann.talk(`Ok! Hehe.`);
        } else if (empty.properties.tempNum === 2) {
            mc.talk(`One more time.`);
            ImageClass.setImage(images.v8.V8AnnDate_39);
            ann.talk(`Ok! Why not!`);

        } else if (empty.properties.tempNum === 3) {
            mc.talk(`Another one!`);
            ImageClass.setImage(images.v8.V8AnnDate_38);
            ann.talk(`Ah... I'm starting to get a bit dizzy.`);
            mc.talk(`You need to catch up for all those times you haven't been here.`);
            ImageClass.setImage(images.v8.V8AnnDate_39);
            ann.talk(`Hehe, ok!`);
        } else if (empty.properties.tempNum === 4) {
            mc.talk(`One more time wouldn't hurt.`);
            ImageClass.setImage(images.v8.V8AnnDate_38);
            ann.talk(`It will hurt my brain...`);
            mc.talk(`Come on!`);
            ann.talk(`Ok.`);

        } else if (empty.properties.tempNum > 4) {
            mc.talk(`Again!`);
            ImageClass.setImage(images.v8.V8AnnDate_38);
            ann.talk(`That's enough! I'll throw up!`);
            mc.talk(`Haha, fine.`);
            return jump(V8AnnDate_Carousel_End, "V8AnnDate_Carousel_End");

        }
        await empty.set((properties) => {
            properties.tempNum++;
        });


    } else {
        return jump(V8AnnDate_Carousel_End, "V8AnnDate_Carousel_End");

    }

    ImageClass.setAnimation(images.v8.Anim_AnnTurning, { duration: 0, wait: true, hideText: true });

    return jump(V8AnnDate_Carousel_2, "V8AnnDate_Carousel_2");
};
export const V8AnnDate_Carousel_End = async (): Promise<any> => {
    mc.talk(`Did you have fun?`);
    ImageClass.setImage(images.v8.V8AnnDate_39);
    ann.talk(`Of course!`);
    if (empty.properties.tempNum > 3) {
        ImageClass.setImage(images.v8.V8AnnDate_41);
        ann.talk(`However, I could have gone for fewer rides...`);
        mc.talk(`I just wanted to make sure you got the most out of it.`);

    }

    return jump(V8AnnDate_Booth, "V8AnnDate_Booth");
};
export const V8AnnDate_Booth = async (): Promise<any> => {

    // TODO: ann corruption
    if (!ann.properties.isCorrupted) {
        doWaitImageByTime(images.v8.V8AnnDate_40);
        stranger.talk(`ATTENTION ATTENTION! GET YOUR FREE PRIZES HERE!`, { method: "Shouting" });
        stranger.talk(`ANYONE CAN WIN! COME GET YOUR FREE PRIZES!`, { method: "Shouting" });
        ann.talk(`Do you hear that?`);
        mc.talk(`I do.`);
        ImageClass.setImage(images.v8.V8AnnDate_39);
        ann.talk(`I love free prizes! Hehe.`);
        mc.talk(`Let's go take a look then.`);
    }



    await stranger.set((properties) => {
        stranger.name = "Vendor";
    });
    doTransition(images.v8.V8AnnDate_42);
    stranger.talk(`GET YOUR FREE PRIZES HERE!`, { method: "Shouting" });
    ImageClass.setImage(images.v8.V8AnnDate_43);
    mc.talk(`Excuse me. Can we give it a try?`);
    ImageClass.setImage(images.v8.V8AnnDate_45);
    stranger.talk(`A CHALLENGER APPEARS!`, { method: "Shouting" });
    doWaitImageByTime(images.v8.V8AnnDate_46);
    stranger.talk(`A long, long time ago people had to hunt to survive!`, { method: "Shouting" });
    stranger.talk(`Every shot was the difference between a meal or starvation!`, { method: "Shouting" });
    stranger.talk(`This is your test, young one, to see if you have what it take to survive in those wild times!`, { method: "Shouting" });
    stranger.talk(`Hit the stars... avoid the birds... get a prize!`, { method: "Shouting" });
    mc.talk(`Why shoot the stars if they were starving?`);
    mc.talk(`Wouldn't it make more sense to shoot animals for food?`);
    ImageClass.setImage(images.v8.V8AnnDate_47);
    stranger.talk(`Are you trying to get me fired?`);
    stranger.talk(`Have you seen the amount of vegans running around these days?`);
    mc.talk(`Fair point...`);
    mc.talk(`Please continue.`);
    doWaitImageByTime(images.v8.V8AnnDate_46);
    stranger.talk(`Ahem ahem.`);
    stranger.talk(`Hit the stars... avoid the birds... get a prize! The more you hit, the bigger the prize. Miss and you walk away empty-handed!`, { method: "Shouting" });

    mc.talk(`Didn't you say that anyone can win?`);
    ImageClass.setImage(images.v8.V8AnnDate_47);
    stranger.talk(`Listen kid, I didn't make up the rules.`);
    stranger.talk(`Just shot the damn stars and get a freaking teddy bear. Alright?`);
    stranger.talk(`I've seen a blind man manage to hit something. So don't sweat it.`);
    mc.talk(`Sounds easy enough.`);
    doWaitImageByTime(images.v8.V8AnnDate_48);
    await mc.setQuestion(new Question({ text: `Alright... So let's see.`, options: { think: true }, key: `V8AnnDateTargetsResults` })
        .option({ title: `Try your hardest`, key: `tryToHit` })
        .option({ title: `Take it easy`, key: `takeItEasy` })
        .option({ title: `Miss on purpose`, key: `missOnPurpose` }));


    if (Question.globalAnswers.V8AnnDateTargetsResults === "tryToHit") {
        ImageClass.setImage(images.v8.V8AnnDate_49);
        empty.think(`Bang! `);
        ImageClass.setImage(images.v8.V8AnnDate_50);
        empty.think(`Hit!`);
        ImageClass.setImage(images.v8.V8AnnDate_51,);
        empty.think(`Bang!  `);
        ImageClass.setImage(images.v8.V8AnnDate_52);
        empty.think(`Hit!`);
        ImageClass.setImage(images.v8.V8AnnDate_49,);
        empty.think(`Bang!   `);
        ImageClass.setImage(images.v8.V8AnnDate_50);
        empty.think(`Hit!`);

        doWaitImageByTime(images.v8.V8AnnDate_54);
        mc.talk(`Sweet! I got all of them!`);
        doWaitImageByTime(images.v8.V8AnnDate_58);
        ann.talk(`Wow! That was impressive!`);

        doWaitImageByTime(images.v8.V8AnnDate_59);
        stranger.talk(`Congratulation! Here is your prize!`);
        ann.talk(`Wow... It's even bigger than Alex's teddy. She will be so jealous!`);
        stranger.talk(`I'm going to hold it here for safekeeping. Come pick it up once you are about to leave the park.`);
        ann.talk(`Hehe. Sounds good, thanks!`);

        ImageClass.setImage(images.v8.V8AnnDate_58);
        ann.talk(`Thank you! This is the best present ever!`);
        mc.talk(`Anything for you!`);

        ImageClass.setImage(images.v8.V8AnnDate_58.partials.V8AnnDate_58_p);
        ann.talk(`I know what we can do next!`);
        ann.talk(`I saw a photo booth on our way in, it would be a great souvenir!`);
        mc.talk(`Let's do it.`);


    } else if (Question.globalAnswers.V8AnnDateTargetsResults === "takeItEasy") {
        ImageClass.setImage(images.v8.V8AnnDate_49,);
        empty.think(`Bang!`);
        ImageClass.setImage(images.v8.V8AnnDate_50);
        empty.think(`Hit!`);

        ImageClass.setImage(images.v8.V8AnnDate_51,);
        empty.think(`Bang!`);
        empty.think(`Miss.`);

        ImageClass.setImage(images.v8.V8AnnDate_49,);
        empty.think(`Bang!`);
        ImageClass.setImage(images.v8.V8AnnDate_50);
        empty.think(`Hit!`);



        doWaitImageByTime(images.v8.V8AnnDate_53);
        mc.talk(`I got only two...`);
        doWaitImageByTime(images.v8.V8AnnDate_58);
        ann.talk(`That's great! I bet that's better than most people!`);


        doWaitImageByTime(images.v8.V8AnnDate_60);
        stranger.talk(`Congratulation! Here is your prize!`);
        ann.talk(`Thank you! It's so cute!`);
        stranger.talk(`You can come and pick it up once you are about to leave the park.`);
        ann.talk(`Hehe. Sounds good, thanks!`);

        ImageClass.setImage(images.v8.V8AnnDate_58);
        ann.talk(`Thank you! This is the best present ever!`);
        mc.talk(`Anything for you!`);


        ImageClass.setImage(images.v8.V8AnnDate_58.partials.V8AnnDate_58_p);
        ann.talk(`I know what we can do next!`);
        ann.talk(`I saw a photo booth on our way in, it would be a great souvenir!`);
        mc.talk(`I agree.`);

    } else {
        ImageClass.setImage(images.v8.V8AnnDate_49);
        empty.think(`Bang!`);
        empty.think(`Miss.`);
        ImageClass.setImage(images.v8.V8AnnDate_51);
        empty.think(`Bang!`);
        empty.think(`Miss.`);
        ImageClass.setImage(images.v8.V8AnnDate_49);
        empty.think(`Bang!`);
        empty.think(`Miss.`);

        doWaitImageByTime(images.v8.V8AnnDate_55);
        stranger.talk(`Sorry kiddo...`);
        ImageClass.setImage(images.v8.V8AnnDate_56);
        stranger.talk(`Maybe not everyone can win...`);
        ImageClass.setImage(images.v8.V8AnnDate_57);
        ann.talk(`Don't worry. I'm sure it's harder than it looks!`);



        await stranger.talk(`ATTENTION ATTENTION? WHO WANTS TO GET A FREE PRIZE?`, { method: "Shouting" });

        await strangerFemale.set((properties) => {
            strangerFemale.name = "Little girl";
        });
        doWaitImageByTime(images.v8.V8AnnDate_62);
        strangerFemale.talk(`Mister mister!`);
        doWaitImageByTime(images.v8.V8AnnDate_63);
        stranger.talk(`Yes little one?`);
        strangerFemale.talk(`Can I try and shoot?`);
        stranger.talk(`I think you are too young for that.\nYou might hurt yourself.`);
        strangerFemale.talk(`I'm seven and a half.`);
        ImageClass.setImage(images.v8.V8AnnDate_63.partials.V8AnnDate_63_p);
        stranger.talk(`That's seems old enough for me.`);

        doTransition(images.v8.V8AnnDate_64);
        empty.think(`Bang!`);
        doWaitImageByTime(images.v8.V8AnnDate_65);
        strangerFemale.talk(`I got one!`);
        strangerFemale.talk(`This is so easy!`);
        ImageClass.setImage(images.v8.V8AnnDate_65.partials.V8AnnDate_66_p);
        ann.talk(`... Let's go somewhere else...`);
    }

    return jump(V8AnnDate_PhotoBooth, "V8AnnDate_PhotoBooth");
};


export const V8AnnDate_PhotoBooth = async (): Promise<any> => {
    doTransition(images.v8.V8AnnDate_68);
    if (Question.globalAnswers.V8AnnDateTargetsResults === "missOnPurpose") {
        ann.talk(`Oh wow! Look at this! It will be a prefect souvenir for today!`);
        mc.talk(`I agree! Let's take a photo.`);
    } else {
        ann.talk(`Seems easy enough. Just smile and click. Hehe.`);
        ann.talk(`Let's try it!`);

    }

    doWaitImageByTime(images.v8.V8AnnDate_67);
    ann.talk(`Don't forget to smile!`);
    ann.talk(`Cheese!`);
    empty.think(`*Clicking Sound*`);
    if (ann.properties.isCorrupted) {
        // ImageClass.setImage(images.v8.V8AnnDate_67.partials.V8AnnDate_67_p_2);
        ann.talk(`Are we ready to go?`);
        ImageClass.setImage(images.v8.V8AnnDate_67);
        mc.talk(`Not yet. I want another picture.`);
        mc.talk(`But this time only of you.`);
        // ImageClass.setImage(images.v8.V8AnnDate_67.partials.V8AnnDate_67_p_2);
        ann.talk(`Hehe, what do you want me to do?`);
        if (Question.globalAnswers.v8AnnDateFlashGuys) {
            // ImageClass.setImage(images.v8.V8AnnDate_67);
            mc.talk(`Well, those two guys back there got a picture of your breasts... What about your boyfriend?`);
            // ImageClass.setImage(images.v8.V8AnnDate_67.partials.V8AnnDate_67_p_2);
            ann.talk(`Hehe, are you serious?`);
            // ImageClass.setImage(images.v8.V8AnnDate_67);
            mc.talk(`I am.`);



        } else {
            mc.talk(`Do something wild.`);
            ann.talk(`Hehe, are you serious?`);
        }
        ann.talk(`Ok! Let me try!`);
        doWaitImageByTime(images.v8.V8AnnDate_67_2);
        empty.think(`*Clicking Sound*`);
    }
    doTransition(images.v8.V8AnnDate_69);
    if (ann.properties.isCorrupted) {
        mc.talk(`The perfect picture to remember you by!`);
        ann.talk(`Hehe, I just hope the photos don't get saved on the machine's memory or something...`);
        mc.talk(`Nah, no way.`);
        ann.talk(`I think we basically did everything, we can leave now.`);
        mc.talk(`Yeah, it's still early and we have plenty of time to practice your acting.`);

    } else {

        ann.talk(`Now we are ready to go!`);
        mc.talk(`I agree... It's about to get dark and Emily is waiting for us.`);
        ann.talk(`I hope it will be a great finale to an amazing day!`);
    }

    return jump(V8AnnDateAfter, "V8AnnDateAfter");
};
